export default "__VITE_ASSET__C0e06kjd__"